import styles from "./styles/button.module.scss";

export function Button(props: {
  text: String;
  width?: number | string;
  onClick?: VoidFunction;
  type?: "submit";
}) {
  return (
    <button
      onClick={props.onClick}
      className={styles.buttonProps}
      type={props.type}
      style={{ width: props.width }}
    >
      {props.text}
    </button>
  );
}

export function SecondaryButton(props: {
  text: String;
  width?: number | string;
  onClick?: VoidFunction;
  type?: "submit";
}) {
  return (
    <button
      onClick={props.onClick}
      className={styles.secondaryButtonProps}
      type={props.type}
      style={{ width: props.width }}
    >
      {props.text}
    </button>
  );
}

export function OutlineButton(props: {
  text: String;
  width?: number | string;
  onClick?: VoidFunction;
  type?: "submit";
}) {
  return (
    <button
      onClick={props.onClick}
      className={styles.outlineButtonProps}
      type={props.type}
      style={{ width: props.width }}
    >
      {props.text}
    </button>
  );
}

export function GlowButton(props: {
  text: String;
  width?: number;
  onClick?: VoidFunction;
  type?: "submit";
}) {
  return (
    <button
      onClick={props.onClick}
      className={styles.buttonPropsGlow}
      type={props.type}
      style={{ width: props.width }}
    >
      {props.text}
    </button>
  );
}
